import worksiteColumns from "../Columns/getWorksiteColumns";

export const modalLoaderUiResolver = (key) => {
  const lookup = {
    formUI9142B_employmentLocationWorksites: {
      columns: worksiteColumns["9142B"],
      createItemKey,
      convertItemFields,
      getFormFields,
    },
    formUI9142C_appx_b_locations: {
      columns: worksiteColumns["9142C"],
      createItemKey,
      convertItemFields,
      getFormFields,
    },
    formUI9089_appx_b_worksites: {
      columns: worksiteColumns["9089"],
      createItemKey,
      convertItemFields,
      getFormFields,
    },
  };
  return lookup[key] || undefined;
};

const getFormFields = (formType, values) => {
  if (formType === "9142B") {
    const {
      pwdDateSubmitted,
      pwdDeterminationDate,
      isEmergency,
      _blsCounties,
    } = values;

    return {
      pwdDateSubmitted,
      pwdDeterminationDate,
      isEmergency,
      _blsCounties,
    };
  } else if (formType === "9142C") {
    const { a5_is_emergency } = values;

    return {
      a5_is_emergency,
    };
  } else if (formType === "9089") {
    const {
      pwdDateSubmitted,
      pwdDeterminationDate,
      is_emergency,
      _blsCounties,
    } = values;
    return {
      pwdDateSubmitted,
      pwdDeterminationDate,
      is_emergency,
      _blsCounties,
    };
  }
};

const convertItemFields = (formType, data, { _blsCounties, rowLength }) => {
  let blsCounties;
  if (_blsCounties) blsCounties = JSON.parse(_blsCounties);

  // for each worksite added get its BLS Area as key and get list of related counties for county select input
  if (formType === "9142B" || formType === "9089") {
    return data.map((item, index) => {
      const _bls_counties = item.worksiteBlsArea
        ? blsCounties[`${item.worksiteBlsArea.toUpperCase()}`]
        : [];
      // set the county object if found as well
      let countyObject =
        _bls_counties[item.worksiteState]?.length &&
        _bls_counties[item.worksiteState].find(
          (county) => county.label === item.worksiteCountyTownship
        );

      let formObject = {};
      if (formType === "9142B") {
        formObject = {
          apdxaMsa: item.worksiteBlsArea,
          apdxaCity: item.worksiteCity,
          apdxaCounty: countyObject || null,
          apdxaState: item.worksiteState,
          apdxaWagePer: item.pwdUnitOfPay,
        };
      } else if (formType === "9089") {
        formObject = {
          appBMsaName: item.worksiteBlsArea,
          appBMsaCode: item.worksiteBlsAreaCode,
          appx_b_city: item.worksiteCity,
          appBCounty: countyObject || null,
          appBState: item.worksiteState,
        };
      }
      return {
        meta_case_submit_date: item.dateSubmitted,
        meta_case_determined_date: item.determinationDate,
        determined_wage_per: item.pwdUnitOfPay,
        determined_wage: item?.pwdWageRate
          ? parseFloat(item.pwdWageRate.toString()).toLocaleString("en", {
              useGrouping: false,
              minimumFractionDigits: 2,
            })
          : null,
        ...formObject,
        sort_order: rowLength + index,
        rowNum: item.rowNum + new Date().getTime().toString(),
      };
    });
  } else if (formType === "9142C") {
    return data.map((item, index) => {
      return {
        appx_b_city: item.worksiteCity,
        appx_b_state_id: item.worksiteState,
        appx_b_zip: item.worksitePostalCode,
        appx_b_wage_freq: item.pwdUnitOfPay,
        sort_order: rowLength + index,
        rowNum: item.rowNum + new Date().getTime().toString(),
      };
    });
  }
};

const createItemKey = (formType, original) => {
  if (formType === "9142B") {
    const {
      worksiteState,
      worksiteCity,
      worksiteCountyTownship,
      worksiteBlsArea,
    } = original;
    const itemKey = `${worksiteState}_${worksiteCity}_${worksiteCountyTownship}_${worksiteBlsArea}`;
    return itemKey;
  } else if (formType === "9142C") {
    const { worksiteCity, worksiteState, worksitePostalCode, worksiteBlsArea } =
      original;
    const itemKey = `${worksiteState}_${worksiteCity}_${worksitePostalCode}_${worksiteBlsArea}`;
    return itemKey;
  } else if (formType === "9089") {
    const {
      worksiteState,
      worksiteCity,
      worksiteCountyTownship,
      worksiteBlsArea,
    } = original;
    const itemKey = `${worksiteState}_${worksiteCity}_${worksiteCountyTownship}_${worksiteBlsArea}`;
    return itemKey;
  }
};
